import { ALLOWED_LOCALES } from '../../../utils/getClientMetadata';

export default (site: string = '', locale: string): boolean => {
  try {
    const query = new URLSearchParams(window.location.search);
    const socialLoginsEnabledQryParamCondition =
      query.get('socialLoginsEnabled') === 'true';
    const allowedLocale: boolean = locale
      ? ALLOWED_LOCALES.findIndex((lcle) => lcle === locale) > -1
      : false;

    switch (true) {
      case site !== 'seekAnz':
        return false;
      case allowedLocale:
        return true;
      default:
        return socialLoginsEnabledQryParamCondition; // AUID-1855 For Go live (phase 2) - this case should be removed and it will be: return true;
    }
  } catch (err) {
    return false;
  }
};
